import { IHouseView } from '../../types/builder';
import { IApplicationState } from '../../types/redux';
import { formatPriceRange, formatMaterials } from '../../utils/formatters';

export const selectBuilderHouses = (state: IApplicationState): IHouseView[] => {
  const houses = state.builderCard.builtHouses || [];

  return houses.map(house => ({
    ...house,
    ...formatPriceRange(house.startPrice),
    materials: formatMaterials(house.materials, house.otherMaterials),
  }));
};
